import { render, staticRenderFns } from "./OrganizationEmailTable.vue?vue&type=template&id=2bf7caf7&"
import script from "./OrganizationEmailTable.vue?vue&type=script&lang=ts&"
export * from "./OrganizationEmailTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf7caf7')) {
      api.createRecord('2bf7caf7', component.options)
    } else {
      api.reload('2bf7caf7', component.options)
    }
    module.hot.accept("./OrganizationEmailTable.vue?vue&type=template&id=2bf7caf7&", function () {
      api.rerender('2bf7caf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/email/OrganizationEmailTable.vue"
export default component.exports